/* eslint-disable no-param-reassign */
import { action, thunk } from 'easy-peasy';
import { fetchPantryReservationFieldsSettings } from '../../services/fbm-api';

export default {
  data: null,
  pantryPath: null,
  loading: false,
  fetch: thunk(async (actions, pantryPath, { getStoreActions }) => {
    try {
      actions.setLoading(true);
      const response = await fetchPantryReservationFieldsSettings(pantryPath);
      actions.set(response.items);
      actions.setPantryPath(pantryPath);
    } catch ({ message }) {
      getStoreActions().notifications.showError({ message });
    } finally {
      actions.setLoading(false);
    }
  }),
  set: action((state, response) => {
    state.data = response;
  }),
  setPantryPath: action((state, pantryPath) => {
    state.pantryPath = pantryPath;
  }),
  clear: action(state => {
    state.data = null;
  }),
  setLoading: action((state, loading) => {
    state.loading = loading;
  })
};
